import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

function InvoiceStats({ invoiceStats }) {
    return (
        <div>
            <h2>Erstellte Rechnungen pro Monat</h2>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={invoiceStats}>
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="count" fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default InvoiceStats;